import {
    GET_ALL_STATE,
    GET_USER_STEP,
    SET_LOADING,
    SET_MODAL,
    SET_USER_STEP
} from "@/store/slices/appSlice";
import {useDispatch, useSelector} from "react-redux";
import {useEffect, useState} from "react";
import Button from "@/components/inputs/button";
import InputWithValidation from "@/components/inputs/inputWithValidation";
import { PaymentTransform } from "@/utils/transform/payment";
import {
    SET_LEAD_CELULAR,
    SET_LEAD_DOCUMENTO,
    SET_LEAD_ORIGEM_VENDA,
    SET_LEAD_TENTATIVA_TEF
} from "@/store/slices/leadSlice";
import ContratoAssinatura from "@/components/texts/contratoAssinatura";

import Events from "@/utils/Events";
import Lead from "@/utils/Lead";
import { GET_OFFER_TYPE } from "@/store/slices/offerSlice";
import Apm from "@/utils/Apm";
import { createPedido } from "@/api/assine";
import { instanceOfIPedido } from "@/types/IPedido";
import { blocked } from "@/utils/EmailBlockedList";
import Nullable from "@/types/utils/Nullable";
import { isDocument, isTelephoneNumber } from "@/utils/validation";
import { isProduction } from "@/utils/environment";
import useRecaptcha from "@/hooks/useRecaptcha";

export default function CortesiaBlock() {
    const events = new Events();
    const dispatch = useDispatch()
    const step = useSelector(GET_USER_STEP)
    const [btnDisabled, setBtn] = useState(false);
    const states = useSelector(GET_ALL_STATE)
    const [all_states, setAllStates] = useState(states)
    const [documento, setDocumento] = useState('')
    const [telefone, setTelefone] = useState('')
    const [documentoErrorMessage, setDocumentoErrorMessage] = useState<Nullable<string>>(null)
    const [telefoneErrorMessage, setTelefoneErrorMessage] = useState<Nullable<string>>(null)
    const recaptcha = useRecaptcha()

    const offer_type = useSelector(GET_OFFER_TYPE)    

    useEffect(() => {
        setAllStates(states)
    }, [states]);

    async function submitData(event: any) {
    event.preventDefault()
        recaptcha.reset();
        const recaptchaToken = await recaptcha.validate('CHECKOUT')
        const recaptchaObj = { token: recaptchaToken, action: 'CHECKOUT' }
        let erroNoFormulario : boolean = false

        if(!isTelephoneNumber(telefone)){
            erroNoFormulario = true
            setTelefoneErrorMessage('Celular inválido')
            events.trigger('cortesia_erro_telefone', { offer_type })
        }

        if(!isDocument(documento)){
            erroNoFormulario = true
            setDocumentoErrorMessage('Documento Inválido')
            events.trigger('cortesia_erro_preencher_documento', { offer_type })
        }

        if(erroNoFormulario){
            return
        }

        setTelefoneErrorMessage('')
        setDocumentoErrorMessage('')

        dispatch(SET_LEAD_DOCUMENTO(documento))
        dispatch(SET_LEAD_CELULAR(telefone))
        const url = new URL(window.location.toString())
        const objectToSend = new PaymentTransform(all_states, 'cortesia', url, {documento, telefone})
        dispatch(SET_LOADING(true))
        const objSend:any = objectToSend.process();
        objSend.recaptcha = recaptchaObj
        if(!objSend){
            Apm.captureError('Erro no arquivo features/Cortesia/index.tsx, objSend era null ou undefined')
            return
        }

        if(instanceOfIPedido(objSend)){
            if(!isNaN(parseInt(objSend.tipo_publicidade))){
                dispatch(SET_LEAD_ORIGEM_VENDA(parseInt(objSend.tipo_publicidade)))
            }else{
                Apm.captureError('Erro no arquivo features/Cortesia/index.tsx, objSend.tipo_publicidade não pode ser convertido para int')
            }
        }else{
            Apm.captureError(`OBJSEND ERA INVÁLIDO NO CORTESIA BLOCK, VALOR: ${JSON.stringify(objSend)}`)
            return
        }

        if(await blocked(objSend.responsavel.email)){
            dispatch(SET_MODAL({show: true, type: 'pagamento-duplicado'}))
            return
        }

    await createPedido(objSend).then((data) => {
            if(typeof data === 'number'){
                Apm.captureError("O RETORNO DO CREATE PEDIDO ERA UM NUMBER NO CORTESIA BLOCK!")
                return
            }

            if(typeof data === 'string'){
                Apm.captureError("O RETORNO DO CREATE PEDIDO ERA UMA STRING NO CORTESIA BLOCK!")
                return
            }

            if (data.id_transacao) {
                events.trigger("cortesia_concluir", { offer_type })
                dispatch(SET_USER_STEP(step + 1))
                dispatch(SET_LEAD_TENTATIVA_TEF('S'))
                dispatch(SET_LEAD_ORIGEM_VENDA(data.id_pedido))
                Lead.save(states.lead.value, dispatch)
            }
        }).catch((e) => {
            events.trigger("concluir_cortesia_negado", { offer_type })
            Apm.captureError(`CortesiaBlock() -> SubmitData(): ${e}`);
            dispatch(SET_MODAL({type: "falha-pagamento", show: true}))
        })
        dispatch(SET_LOADING(false))

    }
    
    return <form onSubmit={submitData}>
        <div>
            <InputWithValidation 
                name="telefone" 
                id="telefone"
                type="text"
                placeholder="Celular"
                OnClick={()=> {
                    events.trigger("cortesia_telefone", { offer_type })
                }}
                onChange={setTelefone}
                errorMessage={telefoneErrorMessage}
                value={telefone}
            />                                  
        </div>
        <div>
            <InputWithValidation 
                name="documento"
                id="documento"
                type="text"
                placeholder="CPF ou CNPJ"
                OnClick={()=> {
                    events.trigger("cortesia_preencher_documento", { offer_type })
                }}
                onChange={setDocumento}
                errorMessage={documentoErrorMessage}
                value={documento}
            />
        </div>
        <Button type={'submit'} disabled={isProduction() && btnDisabled}>Concluir</Button>
        <ContratoAssinatura paymentMethod="cortesia"></ContratoAssinatura>
    </form>
}